export enum PermissionStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const PermissionStatusOptions = [
  {
    label: "Active",
    value: PermissionStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: PermissionStatus.INACTIVE,
  },
];
